import React from "react";
import classNames from "classnames";
const Wrapper = ({ showError, children, className, ...otherProps }) => (<div className={classNames("form-group", className, {
    "has-error": showError
})} {...otherProps}>
		{children}
	</div>);
export default Wrapper;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/Wrapper.tsx